export default "__VITE_ASSET__CRUhHnYO__"